var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('top-toolbar'),_c('v-content',[_c('div',{staticStyle:{"padding":"15px"}},[_c('door-row'),_c('garage-row')],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }